import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { MembersTypes } from "@/types";

export interface MemberInformationState {
  memberInformation: {
    details: MembersTypes.MemberInformationResult;
  };
}

const defaultMemberDetails: MembersTypes.MemberInformationResult = {
  id: null,
  address_line_1: "",
  address_line_2: "",
  address_line_3: "",
  birth_date: "",
  city: "",
  country: "",
  coverage_status: "",
  coverage_type: "",
  created_at: "",
  death_date: "",
  effective_date: "",
  email: "",
  end_date: "",
  external_member_id: "",
  first_name: "",
  group_id: "",
  handicap_indicator: "",
  language_code: "",
  last_name: "",
  location: "",
  multiple_birth_code: "",
  person_code: "",
  phone_number: "",
  plan_id: "",
  ppo_name: "",
  relationship_code: "",
  sex: "",
  social_security_number: "",
  start_date: "",
  state: "",
  termination_date: "",
  updated_at: "",
  zip_code: "",
  miscellaneous_id: "",
  test_member: null,
  test_member_editable: null,
  medicare_indicator: "",
  medicare_beneficiary_identifier: "",
  low_income_subsidy_level: "",
  low_income_subsidy_level_effective_date: "",
  low_income_subsidy_level_termination_date: "",
  hospice_flag: "",
  hospice_flag_effective_date: "",
  hospice_flag_termination_date: "",
  end_stage_renal_disease_flag: "",
  end_stage_renal_disease_flag_effective_date: "",
  end_stage_renal_disease_flag_termination_date: "",
  transplant_patient_flag: "",
  transplant_patient_flag_effective_date: "",
  transplant_patient_flag_termination_date: "",
  cancer_flag: "",
  cancer_flag_effective_date: "",
  cancer_flag_termination_date: "",
  beneficiary_identifier: "",
  contract_number: "",
  plan_benefit_package: "",
  action_type: "",
  other_payer_identification_number: "",
  other_payer_group_number: "",
  other_payer_bin_number: "",
  other_payer_processor_control_number: "",
  other_payer_effective_date: "",
  other_payer_termination_date: "",
};

const DEFAULT_MEMBER_INFORMATION_STATE: MemberInformationState = {
  memberInformation: {
    details: defaultMemberDetails,
  },
};

export default (state: MemberInformationState = DEFAULT_MEMBER_INFORMATION_STATE, action: Action): {} => {
  if (action.type === ActionTypes.GET_MEMBER_INFORMATION_RESULTS) {
    return {
      ...state,
      memberInformation: action.payload,
    };
  } else {
    return state;
  }
};
